// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input__valuationInput___dnz .input-field label{left:0}`, "",{"version":3,"sources":["webpack://./components/Valuation/Input.scss"],"names":[],"mappings":"AAIQ,gDACI,MAAA","sourcesContent":["@import '../../vars.scss';\n\n.valuationInput {\n    :global .input-field {\n        label {\n            left: 0;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"valuationInput": `Input__valuationInput___dnz`
};
export default ___CSS_LOADER_EXPORT___;
